import EventEmitter from "./utils/EventEmitter";

export default class AnalysesStickyBar extends EventEmitter {
  constructor(element) {
    super();

    this.el = element
    this.scroll = window.scrollY

    this.progressBar = this.el.querySelector('.progress-bar')

    // sur le scroll on calcule la progression de la page
    window.addEventListener('scroll', this.handleProgress.bind(this))

    element.addEventListener('click', this.download.bind(this))
  }

  handleProgress() {
    this.scroll = window.scrollY
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight
    const scrolled = (this.scroll / (height - window.innerHeight)) * 100

    this.progressBar.style.width = scrolled + "%"

    // Si le scroll est à 0 pourcent on cache la barre de progression
    if (scrolled === 0) {
      this.el.classList.add('is-hidden')
    } else {
      this.el.classList.remove('is-hidden')
    }
  }

  download() {
    // Find closest link and click it
    const link = this.el.querySelector('.t-btn-download--full a')
    if (link) {
      link.click()
    }
  }
}
